import parse from "html-react-parser";

type IngredientContentItem = {
  tr_content_text: string;
};

type Ingredient = {
  icon?: string | null;
  tr_ingredient_title: string;
  content_list: IngredientContentItem[];
};

type IngredientListProps = {
  tr_heading: string;
  ingredients: Ingredient[];
};

const CheckIcon = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className="check-icon"
  >
    <g
      id="check"
      stroke="none"
      fill="none"
      fillOpacity="0.7"
      fillRule="nonzero"
    >
      <path
        d="M7.13425927,11.8604764 C8.60247927,9.06167636 10.4564793,6.81709636 12.6434793,5.19127636 C13.0351793,4.90069636 13.1163793,4.34660636 12.8257793,3.95602636 C12.5352793,3.56427636 11.9822793,3.48427636 11.5917793,3.77368636 C9.56357927,5.28068636 7.80481927,7.25825636 6.34722927,9.66407636 C5.79077927,8.78877636 5.18256927,8.02177636 4.50847927,7.34413636 C4.16377927,6.99708636 3.60379927,6.99709636 3.26028927,7.34060636 C2.91441927,7.68407636 2.91323927,8.24407636 3.25675927,8.58877636 C4.13554927,9.47227636 4.89198927,10.5404764 5.56843927,11.8545764 C5.72018927,12.1486764 6.02723927,12.3368764 6.35310927,12.333471 C6.68133927,12.333471 6.98249927,12.1509764 7.13425927,11.8604764 Z"
        id="Path"
        fill="var(--primary)"
      />
    </g>
  </svg>
);

export const IngredientList = ({
  tr_heading,
  ingredients,
}: IngredientListProps) => {
  return (
    <section className="ingredients-section content-medium">
      <h2 className="section-heading">{parse(tr_heading)}</h2>

      <div className="ingredients-list">
        {ingredients.map((ingredient, idx) => (
          <div
            className="ingredient-item"
            key={`${ingredient.tr_ingredient_title}-${idx}`}
          >
            {ingredient.icon && (
              <img
                src={ingredient.icon}
                alt={ingredient.tr_ingredient_title}
                className="ingredient-icon"
              />
            )}
            <div className="ingredient-text-content">
              <div className="ingredient-header">
                <h3 className="ingredient-name">
                  {ingredient.tr_ingredient_title}
                </h3>
              </div>

              <div className="ingredient-benefits">
                {ingredient.content_list.map((item, i) => (
                  <div className="benefit-point" key={i}>
                    <CheckIcon />
                    <span>{parse(item.tr_content_text)}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
